import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import AuthStore from './../Auth.store'
import { UIInputCheckbox } from '../../forms/form-fields'
import {
  MDBCollapse,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalDialog,
  MDBModalContent,
  MDBModalTitle,
  MDBBtn,
} from 'mdb-react-ui-kit'

export default observer(() => {
  const [viewTerms, setViewTerms] = useState(false),
    { Terms } = AuthStore,
    SigAgentTerm = (Array.isArray(Terms) ? Terms : []).filter(T => T.get('term_slug') === 'sig-agent-terms').shift(),
    sigAgentTermLink = SigAgentTerm && SigAgentTerm?.get('term_link'),
    shouldPrompt = AuthStore.TermAcceptance.getRequireTerms(AuthStore.email)

  return (
    <div id='SignatureAgentTermsAcceptanceComponent'>
      <MDBCollapse open={shouldPrompt}>
        <div className='sig-term-accept-check form-group offset-top-22'>
          <div className='check-input'>
            <UIInputCheckbox
              name={`accept_sig_agent_terms`}
              id={`accept_sig_agent_terms`}
              onChange={evt => (AuthStore.sig_term_accept = !AuthStore.sig_term_accept)}
              checked={AuthStore.sig_term_accept}
            />
          </div>
          <div className='check-label'>
            <div className='clabel' onClick={evt => (AuthStore.sig_term_accept = !AuthStore.sig_term_accept)}>
              I have read and understand the updated Signature Agent Terms and Conditions.
            </div>
            <div className='chandler' onClick={evt => setViewTerms(true)}>
              Click to view
            </div>
          </div>
        </div>
      </MDBCollapse>
      <MDBModal open={viewTerms} tabIndex='-1' onClose={() => setViewTerms(false)}>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>USA Benefit Group Terms</MDBModalTitle>
              <MDBBtn type='button' className='btn-close' color='none' onClick={() => setViewTerms(false)}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <MDBCollapse open={AuthStore.isFetchingTerms}>
                <div className='loading-spinner'>
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <i className='fa fa-spin fa-spinner' />
                        </td>
                        <td>Loading Terms</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </MDBCollapse>
              <MDBCollapse open={sigAgentTermLink && !AuthStore.isFetchingTerms}>
                <iframe
                  src={sigAgentTermLink}
                  frameBorder='0'
                  allow='autoplay; fullscreen; picture-in-picture'
                  allowFullScreen
                  title={`USABG Signature Agent Terms`}
                  style={{ width: '100%', height: '100%' }}
                ></iframe>
              </MDBCollapse>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </div>
  )
})
